import * as React from 'react';
import dayjsGenerateConfig from 'bonree-picker/lib/generate/dayjs';
import classNames from 'classnames';
import Tabs from '../../../tabs';
import Empty from '../../../empty';
import Spin from '../../../spin';
import generateRangePicker from '../generateRangePicker';
import PopupClose from '../../../_util/bonreeIcons/PopupClose';
import Question from '../../../_util/bonreeIcons/Question';
import LiveTail from '../../../_util/bonreeIcons/LiveTail';
import { parseShortcutValue, GlobalPickerType, durationText, isRecentOpt, isRelatveOpt, isInSpecial, isSpecialTime, parseSpecialTime, computedSpecialList, filterShortcutsByMaxDuration, formatInTimeZone, getTimeZoneEndOfDay, getTimeZoneNow, getTimeZoneStartOfDay, } from '../../util';
import ShortcutList from './ShortcutList';
const RangePicker = generateRangePicker(dayjsGenerateConfig);
const customPrefixCls = 'custom-date-range';
const Panel = props => {
    const { locale } = props;
    const { hasLiveTail, isLiveTail, visibily, format, shortcutList, curShortcut, recentlyUsed, maxDuration, extraHelpContent, pickerPrefixCls, customDisabledDate, customDisabledTime, timeZone, tzOffset, } = props;
    // 特殊日期
    // @ts-ignore
    // eslint-disable-next-line dot-notation
    const specialDate = window === null || window === void 0 ? void 0 : window['Special_Date'];
    const parseDates = React.useCallback((shortcutValue) => isSpecialTime(shortcutValue)
        ? parseSpecialTime(shortcutValue, specialDate, timeZone, tzOffset)
        : parseShortcutValue(shortcutValue, timeZone, tzOffset), [specialDate, timeZone, tzOffset]);
    const formatDate = React.useCallback((date) => formatInTimeZone(date, format, timeZone, tzOffset), [format, timeZone, tzOffset]);
    // 是否隐藏帮助文案
    const [hideHelp, setHideHelp] = React.useState(true);
    // 日期值, 默认是当天时间
    const [customDates, setCustomDates] = React.useState(() => parseDates(curShortcut.value));
    // 日期格式化值
    const [customDateStrings, setCustomDateStrings] = React.useState(['', '']);
    // 假loading
    const [isLoading, setLoaing] = React.useState(false);
    // 面板是否展开
    const [isOpen, setIsOpen] = React.useState(false);
    // 配合面板延迟200ms
    const [delayIsLiveTail, setDelayIsLiveTail] = React.useState(hasLiveTail);
    // 选中tabKey
    const [activeKey, setActiveKey] = React.useState(String(GlobalPickerType.shortcut));
    const { isInvalid, isEqual, isGreater, formatString } = durationText(customDates, maxDuration, locale);
    const relativeList = shortcutList.filter(item => isRelatveOpt(item));
    const specialList = React.useMemo(() => computedSpecialList(locale || {}, specialDate, maxDuration, timeZone, tzOffset), [locale, specialDate, maxDuration, timeZone, tzOffset]);
    // 初始化cutomDates、customDateStrings
    const initDates = () => {
        const dates = parseDates(curShortcut.value);
        setCustomDates(dates);
        if (dates && dates[0] && dates[1]) {
            const dateStrings = [formatDate(dates[0]), formatDate(dates[1])];
            setCustomDateStrings(dateStrings);
        }
        else {
            setCustomDateStrings(['', '']);
        }
    };
    // 禁止选择将来时刻的时分秒
    const generateDisableTime = (date) => {
        if (!date)
            return {};
        const arr24 = [
            0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23,
        ];
        const arr60 = [
            0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25,
            26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48,
            49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59,
        ];
        const now = getTimeZoneNow(timeZone, tzOffset);
        const hour = now.hour();
        const minute = now.minute();
        const second = now.second();
        if (date < getTimeZoneStartOfDay(timeZone, tzOffset))
            return {};
        const disabledHours = () => arr24.filter(h => h > hour);
        const disabledMinutes = (selectedHour) => {
            let disableArr = [];
            if (selectedHour === hour) {
                disableArr = arr60.filter(m => m > minute);
            }
            return disableArr;
        };
        const disabledSeconds = (selectedHour, selectedMinute) => {
            let disableArr = [];
            if (selectedHour === hour && selectedMinute === minute) {
                disableArr = arr60.filter(s => s > second);
            }
            return disableArr;
        };
        return {
            disabledHours,
            disabledMinutes,
            disabledSeconds,
        };
    };
    // 帮助按钮回调
    const handleHelp = () => {
        setHideHelp(!hideHelp);
    };
    // 回传日期值
    const postbackDates = (option) => {
        props.onCurShortcutChange(Object.assign({}, option));
        props.setUpdate(true);
        props.onClose();
    };
    // 待更改日期回调
    const handleCalendarChange = (dates) => {
        if (dates) {
            const [d0, d1] = dates;
            if (d0 && d1) {
                const computedDates = [null, null];
                const computedDateStrings = ['', ''];
                computedDates[0] = d0;
                computedDateStrings[0] = formatDate(d0);
                computedDates[1] = d1;
                computedDateStrings[1] = formatDate(d1);
                setCustomDates(computedDates);
                setCustomDateStrings(computedDateStrings);
            }
        }
    };
    // 点击最近使用
    const handleClickRecently = (index) => {
        const recent = recentlyUsed[index];
        postbackDates(recent);
    };
    // 面板确定按钮回调
    const handleOk = React.useCallback(() => {
        const datestring = customDateStrings.join(' ~ ');
        // 根据detes计算shortcut,将自定义日期转化为shortcut
        const shortcut = {
            type: GlobalPickerType.custom,
            label: datestring,
            value: datestring,
        };
        postbackDates(shortcut);
    }, [customDateStrings.join('~')]);
    const handleCancel = () => {
        props.onCancle();
        props.setUpdate(false);
    };
    React.useEffect(() => {
        setTimeout(() => {
            setDelayIsLiveTail(isLiveTail);
        }, isLiveTail ? 100 : 0);
    }, [isLiveTail]);
    React.useEffect(() => {
        new Promise(resolve => {
            setLoaing(true);
            setTimeout(() => {
                resolve();
            }, 200);
        }).then(() => {
            initDates();
            setLoaing(false);
        });
    }, [curShortcut, timeZone, tzOffset]);
    React.useEffect(() => {
        if (visibily) {
            initDates();
            setTimeout(() => {
                // 模拟点击事件
                document
                    .querySelectorAll(`#${customPrefixCls}-panel-wrap .bonree-picker.bonree-picker-range`)
                    .forEach((dom) => {
                    dom.click();
                });
                setIsOpen(true);
            }, activeKey === String(GlobalPickerType.custom) ? 0 : 200);
        }
        else {
            // 关闭面板，重置customDates、customDateStrings
            setCustomDates(null);
            setCustomDateStrings(['', '']);
            setIsOpen(false);
        }
    }, [visibily, activeKey]);
    const computedRecentlyUsed = () => {
        let list = recentlyUsed;
        if (!(specialDate === null || specialDate === void 0 ? void 0 : specialDate.enable)) {
            list = recentlyUsed.filter(item => !isSpecialTime(item.value));
        }
        list = filterShortcutsByMaxDuration(list, maxDuration, specialDate, timeZone, tzOffset);
        return list;
    };
    const computedDisabledSpecialList = (list) => {
        const disabledList = [];
        list.forEach(item => {
            if (!parseSpecialTime(item.value, specialDate, timeZone, tzOffset)) {
                disabledList.push({
                    value: item.value,
                    popoverContent: '所选时间为非特殊日期，请重新选择',
                });
            }
        });
        return disabledList.concat(props.disabledShortcutOptions || []);
    };
    const customDateRender = currentDate => {
        const inSpecial = isInSpecial(currentDate, specialDate, timeZone, tzOffset);
        return (<div className={classNames(`${pickerPrefixCls}-cell-inner`, {
                [`${customPrefixCls}-cell-inner-special`]: inSpecial,
            })}>
        {Number(formatInTimeZone(currentDate, 'D', timeZone, tzOffset))}
      </div>);
    };
    return (<div className="panel-wrap" id={`${customPrefixCls}-panel-wrap`}>
      <div className="panel-header">
        <div className="time-text-box">
          {delayIsLiveTail ? (<div className="live">
              <span className="live-icon">
                <LiveTail />
              </span>
              <span>Live Tail</span>
            </div>) : (<>
              <div className={classNames('duration', { error: isInvalid || isEqual || isGreater })}>
                {formatString}
              </div>
              <div className="time-text">
                {customDateStrings.every(v => !!v) && customDateStrings.join(' ~ ')}
              </div>
            </>)}
        </div>
        <Question onClick={handleHelp}/>
      </div>
      <div className="panel-body" style={{ display: hideHelp ? 'block' : 'none' }}>
        <Tabs defaultActiveKey={String(GlobalPickerType.shortcut)} onChange={(key) => setActiveKey(key)}>
          <Tabs.TabPane tab={locale.shortcut} key={GlobalPickerType.shortcut}>
            <div className="date-list-wrap">
              <div className="date-list-box">
                <div className="date-list-title">{locale.recent}</div>
                <ShortcutList list={shortcutList.filter(item => isRecentOpt(item))} curShortcut={curShortcut} disabledShortcutOptions={props.disabledShortcutOptions} postbackDates={postbackDates}/>
              </div>
              {relativeList.length > 0 ? (<div className="date-list-box">
                  <div className="date-list-title">{locale.relative}</div>
                  <ShortcutList list={relativeList} curShortcut={curShortcut} disabledShortcutOptions={props.disabledShortcutOptions} postbackDates={postbackDates}/>
                </div>) : null}
              {(specialDate === null || specialDate === void 0 ? void 0 : specialDate.enable) && specialList.length > 0 ? (<div className="date-list-box special">
                  <div className="date-list-title">{locale.specialDate}</div>
                  <ShortcutList list={specialList} curShortcut={curShortcut} disabledShortcutOptions={computedDisabledSpecialList(specialList)} postbackDates={postbackDates}/>
                </div>) : null}
            </div>
          </Tabs.TabPane>
          <Tabs.TabPane forceRender tab={locale.custom} key={GlobalPickerType.custom}>
            <div className={customPrefixCls}>
              {isLoading ? (<Spin size="large"/>) : (<>
                  <div className={`${customPrefixCls}-placeholder`}/>
                  <RangePicker open={isOpen} showTime format={format} timeZone={timeZone} tzOffset={tzOffset} value={customDates} onCalendarChange={handleCalendarChange} getPopupContainer={triggerNdoe => triggerNdoe.parentElement || document.body} onOk={handleOk} onCancel={handleCancel} disabledDate={date => {
                if (customDisabledDate) {
                    return customDisabledDate(date);
                }
                return date && date > getTimeZoneEndOfDay(timeZone, tzOffset);
            }} disabledTime={customDisabledTime || generateDisableTime} okDisabled={isEqual || isGreater} transitionName="none" dateRender={(specialDate === null || specialDate === void 0 ? void 0 : specialDate.enable) ? customDateRender : undefined}/>
                </>)}
            </div>
          </Tabs.TabPane>
          <Tabs.TabPane tab={locale.recentlyUsed} key={GlobalPickerType.recently}>
            <div className="date-list-wrap">
              {computedRecentlyUsed().length > 0 ? (<ul className="date-list">
                  {computedRecentlyUsed().map((used, index) => (<li key={used.label} onClick={() => handleClickRecently(index)}>
                      {used.label}
                    </li>))}
                </ul>) : (<Empty className="date-empty" description="暂无记录"/>)}
            </div>
          </Tabs.TabPane>
        </Tabs>
      </div>
      <div className="help-box" style={{ display: !hideHelp ? 'block' : 'none' }}>
        <div className="help-title">
          {locale.guide} <PopupClose onClick={handleHelp}/>
        </div>
        <div className="help-content">
          <p className="section-text">{locale.tutorialsContent}</p>
          {hasLiveTail ? (<>
              <div className="help-title">{locale.liveTail}</div>
              <p className="section-text">{locale.liveTailContent}</p>
            </>) : null}
          <div className="help-title">{locale.absoluteTime}</div>
          <p className="section-text">{locale.absoluteTimeContent}</p>
          <div className="help-title">{locale.relativeTime}</div>
          <p className="section-text">{locale.relativeTimeConent}</p>
          <div className="help-title">{locale.specialDate}</div>
          <p className="section-text">{locale.specialDateConent}</p>
          {extraHelpContent}
        </div>
      </div>
    </div>);
};
export default Panel;
